/**
 * Which frame PhotoIPCameraModal hands to the shared editor.
 *
 * PhotoIPCameraModal owns the capture — ffmpeg/RTSP through Electron, MJPEG-via-canvas in the
 * browser, and the live preview. Editing is PhotoCaptureModalEnhanced's job, reached in
 * `editOnly` mode with the frame passed as `existingPhoto`.
 *
 * The editor pads whatever it receives by PADDING_RATIO (0.5 per side, i.e. 2x in each dimension)
 * so the operator can zoom out past the image bounds, and opens at ZOOM_FOR_ORIGINAL_FILL (2.0),
 * which cancels that padding exactly and makes the photo fill the crop frame.
 *
 * So the frame handed over must be the UNPADDED one. Handing over the locally-padded copy — a
 * leftover from when this modal had its own cropper — made the editor pad an already-padded
 * image: two paddings, one cancelled by the zoom, so every capture opened at half scale inside a
 * black box and had to be zoomed back in by hand. The bars are real pixels to the cropper, so
 * confirming without correcting stored them in the photo.
 */

export interface CapturedFrames {
  /** The frame exactly as the camera produced it. */
  raw: string | null;
  /** The locally padded copy, kept only as a fallback. */
  padded: string | null;
}

export const capturedFrameForEditor = ({ raw, padded }: CapturedFrames): string | null =>
  raw ?? padded ?? null;
